import React from "react";
import { hydrate, render } from "react-dom";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StyledEngineProvider } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Main Menu Items
import Available from "pages/available/available";
import Collection from "pages/collection/collection-grid";
import Contact from "pages/contact/contact";
import Facility from "pages/facility/facility";
import Home from "pages/home/home";

// Species in Collection
import ArgentineBoas from "pages/collection/argentine-boas";
import BallPython from "pages/collection/ball-pythons";
import BlackPinesnake from "pages/collection/black-pinesnakes";
import BoaConstrictor from "pages/collection/boa-constrictors";
import BrazilianRainbowBoa from "pages/collection/brazilian-rainbow-boas";
import Bullsnakes from "pages/collection/bullsnakes";
import CentralianPython from "pages/collection/centralian-pythons";
import ChineseKingRatsnake from "pages/collection/chinese-king-ratsnakes";
import CoastalCarpetPython from "pages/collection/coastal-carpet-python";
import CornSnakes from "pages/collection/corn-snakes";
import DiamondPython from "pages/collection/diamond-python";
import DumerilsBoa from "pages/collection/dumerils-boa";
import EasternBoxTurtle from "pages/collection/eastern-box-turtle";
import EasternKingsnake from "pages/collection/eastern-kingsnake";
import GrayBandedKingsnake from "pages/collection/gray-banded-kingsnake";
import GreatBasinGopherSnake from "pages/collection/great-basin-gopher-snake";
import HonduranMilkSnake from "pages/collection/honduran-milksnake";
import JungleCarpetPython from "pages/collection/jungle-carpet-python";
import LeopardGecko from "pages/collection/leopard-gecko";
import PapuanCarpetPython from "pages/collection/papuan-carpet-python";
import PlainsHognoseSnake from "pages/collection/plains-hognose-snake";

function Error() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h4">Well that didn't work.</Typography>
    </Box>
  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} errorElement={<Error />}>
      <Route index="true" element={<Collection />} />
      
      {/* Main Menu Items */}
      <Route path="available" element={<Available />} />
      <Route path="contact" element={<Contact />} />
      <Route path="facility" element={<Facility />} />

      {/* Species in Collection */}
      <Route path="argentine-boas" element={<ArgentineBoas />} />
      <Route path="ball-pythons" element={<BallPython />} />
      <Route path="black-pinesnakes" element={<BlackPinesnake />} />
      <Route path="boa-constrictors" element={<BoaConstrictor />} />
      <Route path="brazilian-rainbow-boas" element={<BrazilianRainbowBoa />} />
      <Route path="bullsnakes" element={<Bullsnakes />} />
      <Route path="centralian-pythons" element={<CentralianPython />} />
      <Route path="chinese-king-ratsnakes" element={<ChineseKingRatsnake />} />
      <Route path="coastal-carpet-python" element={<CoastalCarpetPython />} />
      <Route path="corn-snakes" element={<CornSnakes />} />
      <Route path="diamond-python" element={<DiamondPython />} />
      <Route path="dumerils-boa" element={<DumerilsBoa />} />
      <Route path="eastern-kingsnake" element={<EasternKingsnake />} />
      <Route path="gray-banded-kingsnake" element={<GrayBandedKingsnake />} />
      <Route path="great-basin-gopher-snake" element={<GreatBasinGopherSnake />} />
      <Route path="honduran-milksnake" element={<HonduranMilkSnake />} />
      <Route path="jungle-carpet-python" element={<JungleCarpetPython />} />
      <Route path="papuan-carpet-python" element={<PapuanCarpetPython />} />
      <Route path="plains-hognose-snake" element={<PlainsHognoseSnake />} />
      <Route path="leopard-gecko" element={<LeopardGecko />} />
      <Route path="eastern-box-turtle" element={<EasternBoxTurtle />} />

      {/* Default/Error */}
      <Route path="*" element={<Error />} />
    </Route>
  )
);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(
    <React.StrictMode>
      <StyledEngineProvider injectFirst>
        <RouterProvider router={router}></RouterProvider>
      </StyledEngineProvider>
    </React.StrictMode>,
    rootElement
  );
} else {
  render(
    <React.StrictMode>
      <StyledEngineProvider injectFirst>
        <RouterProvider router={router}></RouterProvider>
      </StyledEngineProvider>
    </React.StrictMode>,
    rootElement
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
